export type CheckoutIdempotencyScope = 'order' | 'payment';

/** Client-generated key for a single checkout or payment submit attempt. */
export function createCheckoutIdempotencyKey(scope: CheckoutIdempotencyScope): string {
  return `${scope}_${Date.now()}_${Math.random().toString(36).slice(2, 11)}`;
}
